/******************************************************
 *                  Update Ctrl
 ********************************************************/

"use strict";

angular.module("admin")

	.controller("UpdateCtrl", ["$scope", "toastr", "Utils", "$uibModal", "UpdateService", function ($scope, toastr, Utils, $uibModal, UpdateService) {

		$scope.data = {
			token: "",
			tokenAccepted: false
		};

		$scope.checkToken = function () {
			UpdateService.checkToken($scope.data.token)
				.then(() => {
					$scope.data.tokenAccepted = true;
					toastr.success("L'authentification est acceptée.");
					$scope.getAllInfos();
				})
				.catch((error) => {
					toastr.error(Utils.makeErrorMessage(error.data, "L'authentification n'est pas correcte "), "Erreur");
				});
		};

		$scope.postInfo = function (info) {
			UpdateService.postInformation(info, $scope.data.token)
				.then(() => {
					toastr.success("L'information a été ajoutée");
					$scope.getAllInfos();
					$scope.data.form = {};
					setTimeout(function () {
						$scope.getAllInfos();
					}, 20000);
				})
				.catch((error) => {
					toastr.error(Utils.makeErrorMessage(error.data, "L'action n'a pas été prise en compte"), "Erreur");
				});
		};

		$scope.clearInformation = function () {
			UpdateService.clearInformation($scope.data.token)
				.then(() => {
					toastr.success("La liste est bien purgée.");
					$scope.getAllInfos();
				})
				.catch((error) => {
					toastr.error(Utils.makeErrorMessage(error.data, "L'action n'a pas été prise en compte"), "Erreur");
				});
		};

		$scope.getAllInfos = function () {
			UpdateService.getInformations()
				.then((response) => {
					$scope.data.informations = response.data;
				})
				.catch((error) => {
					toastr.error(Utils.makeErrorMessage(error.data, "L'action n'a pas été prise en compte"), "Erreur");
				});
		};

	}]
	)
;
